import Wrapper from '@/components/atoms/legacy/Wrapper';
import FrequentlyAskedQuestions from '@/components/organisms/FrequentlyAskedQuestions';
import NewPartnerPageBanner from '@/components/organisms/NewPartnerPageBanner/NewPartnerPageBanner';
import { NewPartnerPageBenefits } from '@/components/organisms/NewPartnerPageBenefits/NewPartnerPageBenefits';
import { PartnerPagePackages } from '@/components/organisms/PartnerPagePackages';
import React from 'react';

const PartnerLandingTemplate: React.FC = () => {
  return (
    <>
      <Wrapper>
        <NewPartnerPageBanner />
      </Wrapper>
      <Wrapper className="bg-[#041441]">
        <NewPartnerPageBenefits />
      </Wrapper>
      <Wrapper>
        <PartnerPagePackages />
      </Wrapper>
      <Wrapper className="bg-blue-light">
        <div className="py-[60px] m:py-[80px]">
          <FrequentlyAskedQuestions
            subHeading="Everything you need to know about EV.com"
            headingClassName="text-display32px text-neutral-900"
            questionGroups={[
              {
                questions: [
                  {
                    header: 'What does partnering with EV.com entail?',
                    text: "By partnering with EV.com, you'll be joining a network of elite dealerships focused on the growing electric vehicle market. You'll gain access to our vast online audience of EV enthusiasts, comprehensive market analytics, and innovative digital tools to drive more customers to your dealership.",
                  },
                  {
                    header:
                      "How can EV.com help increase my dealership's sales?",
                    text: 'EV.com connects dealerships with a targeted audience specifically interested in electric vehicles. We provide visibility to your inventory on a platform frequented by thousands of potential buyers daily, which can help drive more leads, conversions, and ultimately increase sales.',
                  },
                  {
                    header:
                      'What type of dealerships does EV.com partner with?',
                    text: "EV.com partners with a wide range of dealerships that are passionate about the EV market. Whether you're a large franchise, an independent dealership, or a specialty EV dealer, as long as you have a dedication to customer service and a commitment to the EV movement, we'd love to work with you.",
                  },
                  {
                    header:
                      'What kind of support does EV.com provide to its dealership partners?',
                    text: 'Our dealership partners receive continuous support from our dedicated partner relations team. We offer tools and resources for inventory management, market analytics, and digital marketing. Additionally, we provide training and support to help you make the most of these tools.',
                  },
                  {
                    header: `How does EV.com's platform work?`,
                    text: "EV.com's platform is a digital marketplace designed specifically for electric vehicles. Potential buyers can browse and compare vehicles, read reviews, and get in touch with dealerships. As a dealership partner, you can list your inventory, track leads and conversions, and access a suite of tools designed to help you sell more effectively.",
                  },
                  {
                    header: 'How can we join EV.com as a dealership partner?',
                    text: 'Joining EV.com as a dealership partner is simple. Just click on the "Become a Partner" button on our website and fill out the application form. Once we receive your application, a member of our team will reach out to you to discuss the next steps.',
                  },
                  {
                    header: 'What is the cost of partnering with EV.com?',
                    text: 'The cost of partnering with EV.com can vary based on the size of your dealership and the services you need. We recommend contacting us directly for a customized quote.',
                  },
                  {
                    header:
                      'How does EV.com ensure the quality of dealerships on its platform?',
                    text: 'EV.com is committed to promoting only the most reputable dealerships. We vet all potential partners for a history of excellent customer service, fair pricing, and a commitment to the EV industry. Furthermore, we encourage user reviews and feedback to maintain a high-quality network of dealerships.',
                  },
                  {
                    header:
                      'What kind of training and resources does EV.com provide?',
                    text: "EV.com provides comprehensive training on how to use our platform effectively, along with resources on the latest market trends, sales strategies, and best practices in the EV industry. We're committed to empowering our partners with the knowledge they need to succeed.",
                  },
                  {
                    header:
                      'Does EV.com provide marketing and promotional support?',
                    text: 'Yes, as a part of our dealership partner program, we provide various marketing and promotional support. This can range from digital marketing tools, featured listings, to opportunities for promotion on our social media channels and newsletters.',
                  },
                ],
              },
            ]}
          />
        </div>
      </Wrapper>
    </>
  );
};

export default PartnerLandingTemplate;
